import React from "react";
import { AiOutlineArrowRight } from "react-icons/ai";

const Achive = () => {
  const achievements = [
    "🏆 Bessemer Product Fellow",
    "🍱 20,000+ followers on Little Red Book (小红书)",
    "🏸 6-time national badminton champion — Team USA World Juniors",
    "🥇 Former varsity golf captain"
  ];

  return (
    <div id="blog" className="portfolio">
      <h1 className="mainHeading">My Achievements</h1>
      <p className="mainPara">Highlights & Milestones</p>
      <div className="projects">
        {achievements.map((item, index) => (
          <div className="project" key={index} style={{padding: "15px"}}>
            <h4 className="projectTitle" style={{fontSize: "1.3rem", padding: "0px"}}>{item}</h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Achive;
